module.exports = __webpack_public_path__ + "static/media/no_skills.9560c63c.svg";